import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { LicenceStatusDto } from '../../../../../aumico-lib-users-fe/src/lib/dtos/licenceStatusDto';

@Component({
    selector: 'app-licence-banner',
    templateUrl: './licence-banner.component.html',
    styleUrls: ['./licence-banner.component.scss'],
})
export class LicenceBannerComponent {
    constructor(private i18next: I18NextService) {}
    @Input() status: LicenceStatusDto = undefined;
    @Output() dismiss = new EventEmitter<void>();
    @Output() requestMore = new EventEmitter<void>();

    // –– bind the native `hidden` attribute on the host
    @HostBinding('attr.hidden') get hidden() {
        return !this.isVisible ? '' : null;
    }

    onDismiss() {
        this.dismiss.emit();
    }

    onRequestMore() {
        this.requestMore.emit();
    }

    get isVisible(): boolean {
        return this.status !== undefined && this.status?.available < 6;
    }

    get message(): string | null {
        if (this.status?.available <= 0) {
            return this.i18next.t('aumico_licence_banner_max_reached').toString();
        } else if (this.status?.available < 6) {
            return this.i18next
                .t('aumico_licence_banner_max_is_nearing', { replace: { value: this.status?.available } })
                .toString();
        } else {
            return null;
        }
    }
}
